const staticRedisKeys = {
  OFFER_DURATION: "offer:durations",
  CATALOG_CATEGORIES: "catalog:categories",
} as const;

const dynamicRedisKeys = {
  PRODUCT_DETAILS: (id: string): `catalog:product:${string}` =>
    `catalog:product:${id}`,
  CATEGORY_PRODUCTS: (params: string): `category:products:${string}` =>
    `category:products:${params}`,
  CATEGORY_MOSTVIEWED: (id: string): `category:mostviewed:${string}` =>
    `category:mostviewed:${id}`,
};

export const redisKeys = {
  ...staticRedisKeys,
  ...dynamicRedisKeys,
};

type StaticRedisKey = (typeof staticRedisKeys)[keyof typeof staticRedisKeys];
type DynamicRedisKey = ReturnType<
  (typeof dynamicRedisKeys)[keyof typeof dynamicRedisKeys]
>;
export type RedisKeyType = StaticRedisKey | DynamicRedisKey;
